import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';
import { sketchDefaultData } from '@modules/sketch/pages/create/constants';

import * as actions from '../actions/search';

const initialState = fromJS({
  config: { data: [], state: null },
  codes: { data: {}, state: null },
  resultsConfig: { data: [], state: null },
  results: { data: [], state: null },
  executePreview: {
    data: [],
    recordCount: 0,
    columnOrder: [],
    state: null,
    errorMsg: '',
  },
  taxingUnits: {
    state: null,
    data: {
      taxingUnits: [],
    },
  },
  ciSettings: {
    state: null,
    lastUpdate: null,
    data: {
      layoutData: {
        layout: 1,
        maps: [
          {
            type: 'gismap',
          },
          {
            type: 'googlemap',
          },
          {
            type: 'googlemap',
          },
        ],
      },
      ciImageryData: [
        {
          value: 'gismap',
          label: 'GIS',
          visible: true,
        },
        {
          value: 'pictometry',
          label: 'Pictometry',
          visible: true,
        },
        {
          value: 'googlemap',
          label: 'Google Map',
          visible: true,
        },
        {
          value: 'googlemapaerial',
          label: 'Google Aerial',
          visible: true,
        },
        {
          value: 'googlemapstreetview',
          label: 'Google Street View',
          visible: true,
        },
        {
          value: 'googlemappictometry',
          label: 'Google Tilt',
          visible: true,
        },
        {
          value: 'bingmap',
          label: 'Bing Map',
          visible: true,
        },
        {
          value: 'bingmapaerial',
          label: 'Bing Aerial',
          visible: true,
        },
        {
          value: 'bingmapstreetview',
          label: 'Bing Street View',
          visible: true,
        },
        {
          value: 'bingmappictometry',
          label: 'Bing Birds Eye',
          visible: true,
        },
      ],
    },
  },
  gisSettings: {
    state: null,
    lastUpdate: null,
    publicSiteMapSettings: {},
    data: {
      authData: {
        type: 'mapServer',
        authToken: '',
        mapServerUrl:
          'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
        fileLocation: '',
      },
      themeData: [
        {
          value: 'default',
          settingsLabel: 'Open Layers Default',
          visible: true,
          selected: true,
          serviceUrl: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          format: 'EPSG:2276',
          type: 'xyz',
        },
        {
          value: 'bingmap',
          settingsLabel: 'Bing Map',
          visible: true,
          selected: false,
          serviceUrl: null,
          format: 'EPSG:2276',
          type: 'native',
        },
        {
          value: 'bingmapaerial',
          settingsLabel: 'Bing Map Aerial',
          visible: true,
          selected: false,
          serviceUrl: null,
          format: 'EPSG:2276',
          type: 'native',
        },
        {
          value: 'arcgis',
          settingsLabel: 'Arc GIS',
          visible: true,
          selected: false,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          format: 'EPSG:2276',
          type: 'arcgis',
        },
        {
          value: 'floodplain',
          settingsLabel: 'Floodplain Map',
          visible: true,
          selected: false,
          serviceUrl:
            'https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer/',
          format: 'EPSG:2276',
          type: 'arcgis',
        },
        {
          value: 'terrain',
          settingsLabel: 'Terrain Map',
          visible: true,
          selected: false,
          serviceUrl:
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
          format: 'EPSG:2276',
          type: 'xyz',
        },
      ],
      layerData: [
        {
          value: 'schoolLayer',
          settingsLabel: 'School Districts',
          color: '#000001',
          opacity: 1,
          visibility: 200,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['1'],
          format: 'EPSG:2276',
          displayInfo: 'ISDNAME',
          label: null,
          display: false,
        },
        {
          value: 'roadLayer',
          settingsLabel: 'Roads',
          color: '#000001',
          opacity: 1,
          visibility: 2,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['5'],
          format: 'EPSG:2276',
          displayInfo: null,
          label: null,
          display: false,
        },
        {
          value: 'waterLayer',
          settingsLabel: 'Streams',
          color: '#000001',
          opacity: 1,
          visibility: 2,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['10'],
          format: 'EPSG:2276',
          displayInfo: null,
          label: null,
          display: false,
        },
        {
          value: 'abstractLayer',
          settingsLabel: 'Abstracts',
          color: '#000001',
          opacity: 1,
          visibility: 50,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['0'],
          format: 'EPSG:2276',
          displayInfo: 'ABSTRACTNO',
          label: null,
          display: false,
        },
        {
          value: 'subdivisionLayer',
          settingsLabel: 'Subdivisions',
          color: '#000001',
          opacity: 1,
          visibility: 5,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['8'],
          format: 'EPSG:2276',
          displayInfo: 'NAME',
          label: null,
          display: false,
        },
        {
          value: 'floodplainLayer',
          settingsLabel: 'Floodplains',
          color: '#000001',
          opacity: 1,
          visibility: 20,
          visible: true,
          serviceUrl:
            'https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer/',
          layerNum: ['27'],
          format: 'EPSG:3857',
          displayInfo: null,
          label: null,
          display: false,
        },
        {
          value: 'parcelLayer',
          settingsLabel: 'Parcels',
          color: '#000001',
          opacity: 1,
          visibility: 0.3,
          visible: true,
          serviceUrl:
            'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
          layerNum: ['14'],
          format: 'EPSG:2276',
          displayInfo: 'SDE.SDE.parcel_polygon.PROP_ID',
          label: 'propertyID',
          display: false,
        },
      ],
      attributeData: [
        {
          value: 'propertyID',
          settingsLabel: 'Property ID',
          visible: true,
          selected: true,
          displayInfo: 'SDE.SDE.parcel_polygon.PROP_ID',
        },
        {
          value: 'ownerName',
          settingsLabel: 'Owner Name',
          visible: true,
          selected: false,
          displayInfo: 'SDE.dbo.AD_Public.file_as_name',
        },
      ],
    },
  },
  appraisalMapData: {
    state: 'null',
    data: {
      open: false,
      selectMode: false,
      buttonStyle: 'checkbox',
      recordID: null,
      loaded: false,
      sync: true,
      zoom: 10,
      zoomChange: false,
      fullScreen: false,
      activeLayerIndex: 0,
      lastModifiedIndex: -1,
      configuration: 3,
      lat: 33.0836955,
      lng: -96.6400742,
      cameraLat: null,
      cameraLng: null,
      addressLat: null,
      addressLng: null,
      address: '',
      addresses: [],
      addressesLoaded: true,
      shortDescription: '',
      windowData: [
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
        {
          type: 'gismap',
          zoom: 18,
          data: {
            drawerData: {
              state: null,
              data: {},
            },
            popupData: {
              state: null,
              data: {},
            },
            queryData: {
              state: null,
              data: {},
            },
            textData: {
              state: null,
              data: [],
            },
            selectData: {
              state: null,
              data: [],
            },
          },
        },
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
      ],
      layerData: [
        {
          lastModifiedIndex: -1,
          configuration: 1,
          lat: 31.290626,
          lng: -98.667445,
          cameraLat: null,
          cameraLng: null,
          addressLat: 31.290626,
          addressLng: -98.667445,
          address: '',
          shortDescription: '',
          windowData: [
            {
              type: 'googlemap',
              data: {},
            },
            {
              type: 'googlemapaerial',
              data: {},
            },
            {
              type: 'googlemap',
              data: {},
            },
          ],
        },
      ],
    },
  },
  editSketch: {
    state: 'fetching',
    data: {
      ...JSON.parse(JSON.stringify(sketchDefaultData)),
      table: [
        {
          improvementDetail: 'N/A',
          area: 0,
          perimeter: 0,
          nodes: 0,
          arcs: 0,
        },
      ],
    },
  },
  mapData: {
    state: 'null',
    data: {
      recordID: null,
      loaded: false,
      sync: true,
      zoom: 18,
      zoomChange: false,
      fullScreen: false,
      activeLayerIndex: 0,
      lastModifiedIndex: -1,
      configuration: 1,
      lat: 31.290626,
      lng: -98.667445,
      cameraLat: null,
      cameraLng: null,
      addressLat: 31.290626,
      addressLng: -98.667445,
      address: '',
      shortDescription: '',
      windowData: [
        {
          type: 'gismap',
          zoom: 18,
          data: {
            drawerData: {
              state: null,
              data: {},
            },
            popupData: {
              state: null,
              data: {},
            },
            queryData: {
              state: null,
              data: {},
            },
            textData: {
              state: null,
              data: [],
            },
            selectData: {
              state: null,
              data: [],
            },
          },
        },
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
      ],
      layerData: [
        {
          lastModifiedIndex: -1,
          configuration: 1,
          lat: 31.290626,
          lng: -98.667445,
          cameraLat: null,
          cameraLng: null,
          addressLat: 31.290626,
          addressLng: -98.667445,
          address: '',
          shortDescription: '',
          windowData: [
            {
              type: 'googlemap',
              data: {},
            },
            {
              type: 'googlemapaerial',
              data: {},
            },
            {
              type: 'googlemap',
              data: {},
            },
          ],
        },
      ],
    },
  },
  comments: {
    state: null,
    data: [],
  },
  tags: {
    state: null,
    data: [],
  },
  addressFetchData: {
    state: null,
    data: {},
  },
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_PID_ADDRESS_DATA_SUCCESS: {
      return state
        .setIn(['addressFetchData', 'state'], fetchingState.LOADED)
        .setIn(['addressFetchData', 'data'], fromJS(action.data.results));
    }
    case actions.GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS: {
      let newMapData = state.getIn(['appraisalMapData', 'data']).toJS();
      let newAddresses = [];
      let record = action.data.results[0];
      let address = `${record.streetNum} ${record.streetName} ${record.city} ${record.state} ${record.zip}`;
      address = `${record.streetNum} ${record.streetName} ${record.city} ${record.state} ${record.zip}`;
      newAddresses.push({
        pid: action.data.results[0].pid,
        address: address,
        lat: null,
        lng: null,
      });
      newMapData.addresses = newAddresses;
      newMapData.addressesLoaded = false;
      newMapData.loaded = true;
      return state.setIn(['appraisalMapData', 'data'], fromJS(newMapData));
    }
    case actions.GET_APPRAISAL_SEARCH_DATA_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'loaded',
        data: action.data && action.data.results ? action.data.results : [],
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'loaded',
        data: action.data.results,
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'loaded',
        data: action.data.results,
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'loaded',
        data: action.data.results,
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_CI_API_SETTINGS_SUCCESS: {
      let settings = action.data.results[0].settings;
      if (!settings || !settings.ciImageryData || !settings.layoutData) {
        settings = {
          layoutData: {
            layout: 1,
            maps: [
              {
                type: 'gismap',
              },
              {
                type: 'googlemap',
              },
              {
                type: 'googlemap',
              },
            ],
          },
          ciImageryData: [
            {
              value: 'gismap',
              label: 'GIS',
              visible: true,
            },
            {
              value: 'pictometry',
              label: 'Pictometry',
              visible: true,
            },
            {
              value: 'googlemap',
              label: 'Google Map',
              visible: true,
            },
            {
              value: 'googlemapaerial',
              label: 'Google Aerial',
              visible: true,
            },
            {
              value: 'googlemapstreetview',
              label: 'Google Street View',
              visible: true,
            },
            {
              value: 'googlemappictometry',
              label: 'Google Tilt',
              visible: true,
            },
            {
              value: 'bingmap',
              label: 'Bing Map',
              visible: true,
            },
            {
              value: 'bingmapaerial',
              label: 'Bing Aerial',
              visible: true,
            },
            {
              value: 'bingmapstreetview',
              label: 'Bing Street View',
              visible: true,
            },
            {
              value: 'bingmappictometry',
              label: 'Bing Birds Eye',
              visible: true,
            },
          ],
        };
      }
      return state
        .setIn(['ciSettings', 'state'], fetchingState.LOADED)
        .setIn(
          ['ciSettings', 'lastUpdate'],
          fromJS(action.data.results[0].updateDt),
        )
        .setIn(['ciSettings', 'data'], fromJS(settings));
    }
    case actions.GET_GIS_API_SETTINGS_SUCCESS: {
      let settings = action.data.results[0].settings;
      let publicThemeData = action.data?.publicMapResults[0]?.publicSiteMapSettings?.themeData;
      if(!publicThemeData) {
        publicThemeData = [];
      }
      if (!settings) {
        settings = {
          authData: {
            type: 'mapServer',
            authToken: '',
            mapServerUrl:
              'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
            fileLocation: '',
          },
          themeData: [
            {
              value: 'default',
              settingsLabel: 'Open Layers Default',
              visible: true,
              selected: true,
              serviceUrl:
                'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              format: 'EPSG:2276',
              type: 'xyz',
            },
            {
              value: 'bingmap',
              settingsLabel: 'Bing Map',
              visible: true,
              selected: false,
              serviceUrl: null,
              format: 'EPSG:2276',
              type: 'native',
            },
            {
              value: 'bingmapaerial',
              settingsLabel: 'Bing Map Aerial',
              visible: true,
              selected: false,
              serviceUrl: null,
              format: 'EPSG:2276',
              type: 'native',
            },
            {
              value: 'arcgis',
              settingsLabel: 'Arc GIS',
              visible: true,
              selected: false,
              serviceUrl:
                'https://map.collincad.org/gis/rest/services/Dynamic/Gen/MapServer/',
              format: 'EPSG:2276',
              type: 'arcgis',
            },
            {
              value: 'floodplain',
              settingsLabel: 'Floodplain Map',
              visible: true,
              selected: false,
              serviceUrl:
                'https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer/',
              format: 'EPSG:2276',
              type: 'arcgis',
            },
            {
              value: 'terrain',
              settingsLabel: 'Terrain Map',
              visible: true,
              selected: false,
              serviceUrl:
                'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
              format: 'EPSG:2276',
              type: 'xyz',
            },
          ],
          layerData: [],
          attributeData: [],
        };
      }
      return state
        .setIn(['gisSettings', 'state'], fetchingState.LOADED)
        .setIn(
          ['gisSettings', 'lastUpdate'],
          fromJS(action.data.results[0].updateDt),
        )
        .setIn(['gisSettings', 'publicSiteMapSettings', 'themeData'], fromJS(publicThemeData))
        .setIn(['gisSettings', 'data'], fromJS(settings));
    }
    case actions.SET_CI_API_SETTINGS_SUCCESS: {
      return state
        .setIn(['ciSettings', 'state'], fetchingState.LOADED)
        .setIn(
          ['ciSettings', 'lastUpdate'],
          fromJS(action.data.results[0].updateDt),
        )
        .setIn(['ciSettings', 'data'], fromJS(action.data.results[0].settings));
    }
    case actions.SET_GIS_API_SETTINGS_SUCCESS: {
      return state
        .setIn(['gisSettings', 'state'], fetchingState.LOADED)
        .setIn(
          ['gisSettings', 'lastUpdate'],
          fromJS(action.data.results[0].updateDt),
        )
        .setIn(
          ['gisSettings', 'data'],
          fromJS(action.data.results[0].settings),
        );
    }
    case actions.GET_POPUP_CONTENT_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'loaded',
        data: [
          ['Current Year', action.data.results.currentYear],
          ['Property ID', action.data.results.propertyInfo.pid],
          ['Owner Name', action.data.results.ownerInfo[0].name],
        ],
        propType: action.data.results.propertyInfo.propType,
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'loaded',
        data: [
          ['Current Year', action.data.results.currentYear],
          ['Property ID', action.data.results.propertyInfo.pid],
          ['Owner Name', action.data.results.ownerInfo[0].name],
        ],
        propType: action.data.results.propertyInfo.propType,
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_TAXING_UNITS_SUCCESS: {
      return state
        .setIn(['taxingUnits', 'state'], fetchingState.LOADED)
        .setIn(['taxingUnits', 'data'], fromJS(action.data.results));
    }
    case actions.EXECUTE_SMARTLIST_QUERY_START:
      return state
        .setIn(['executePreview', 'errorMsg'], '')
        .setIn(['executePreview', 'recordCount'], 0)
        .setIn(['executePreview', 'data'], fromJS([]))
        .setIn(['executePreview', 'state'], fetchingState.FETCHING);
    case actions.EXECUTE_SMARTLIST_QUERY_SUCCESS:
      let newState = JSON.parse(JSON.stringify(state));
      let data = action.data;
      newState = state.setIn(['executePreview', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['executePreview', 'recordCount'],
        data.results.recordCount,
      );
      newState = newState.setIn(
        ['executePreview', 'columnOrder'],
        fromJS(
          data && data.results.queryResults[0]
            ? Object.keys(data.results.queryResults[0])
            : [],
        ),
      );
      if (data.results.query) {
        newState = newState.setIn(
          ['executePreview', 'query'],
          fromJS(data && data.results.query ? data.results.query : null),
        );
      }
      if (data.results.pIDQuery) {
        newState = newState.setIn(
          ['executePreview', 'pIDQuery'],
          fromJS(data && data.results.pIDQuery ? data.results.pIDQuery : null),
        );
      }
      return newState.setIn(
        ['executePreview', 'data'],
        fromJS(data ? data.results.queryResults : []),
      );
    case actions.EXECUTE_SMARTLIST_QUERY_ERROR:
      return state
        .setIn(['executePreview', 'state'], fetchingState.ERROR)
        .setIn(['executePreview', 'errorMsg'], `error`);
    case actions.GET_TAGS_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
    }
    case actions.POST_TAG_SUCCESS: {
      // console.log('post tag');
      // console.log(action);
      // console.log(action.payload.tag);
      // let newNotes = state.getIn([ 'tags', 'data' ]).toJS();
      // newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.DELETE_TAG_SUCCESS: {
      // console.log('post comment');
      // console.log(action);
      // console.log('delete tag');
      // console.log(action);
      // let newNotes = state.getIn([ 'comments', 'data' ]).toJS();
      // newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.GET_COMMENTS_SUCCESS: {
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(action.data.results));
    }
    case actions.POST_COMMENT_SUCCESS: {
      // console.log('post comment');
      // console.log(action);
      let newNotes = state.getIn(['comments', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(newNotes));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.DELETE_COMMENT_SUCCESS: {
      return state.setIn(['comments', 'state'], fetchingState.LOADED).setIn(
        ['comments', 'data'],
        fromJS(
          state
            .get('comments')
            .toJS()
            .data.filter(note => note.commentID !== action.payload),
        ),
      );
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.CREATE_CI_RECORD_SUCCESS: {
      return state.setIn(['results', 'state'], fetchingState.LOADED);
    }
    case actions.DELETE_CI_RECORD_SUCCESS: {
      return state.setIn(['results', 'state'], fetchingState.LOADED).setIn(
        ['results', 'data'],
        fromJS(
          state
            .get('results')
            .toJS()
            .data.filter(record => record.ciID !== action.payload),
        ),
      );
    }
    case actions.EDIT_CI_RECORD_SUCCESS: {
      const result = action.data.results[0];
      // result.table = [];
      // for (let x = 1; x <= result.sketchCommands[2].detailList.length; x++) {
      //   let nodes = 0;
      //   let area = 0;
      //   const improvementDetail = result.sketchCommands[2].detailList[x - 1];
      //   let arcs = 0;
      //   let perimeter = 0;
      //   const newRow = {};
      //   for (let y = 0; y < result.sketchCommands[0].details.length; y++) {
      //     if (result.sketchCommands[0].details[y].detailInfo === x) {
      //       if (result.sketchCommands[0].details[y].area) {
      //         if (result.sketchCommands[0].details[y].type === 'xgon') {
      //           nodes += result.sketchCommands[0].details[y].numSides;
      //         } else if (
      //           result.sketchCommands[0].details[y].type !== 'circle'
      //         ) {
      //           nodes =
      //             nodes +
      //             result.sketchCommands[0].details[y].coordinates.length -
      //             1;
      //         }
      //       } else {
      //         nodes += result.sketchCommands[0].details[y].coordinates.length;
      //       }
      //       area += result.sketchCommands[0].details[y].area;
      //       perimeter += result.sketchCommands[0].details[y].perimeter;
      //       for (
      //         let z = 0;
      //         z < result.sketchCommands[0].details[y].arcData.length;
      //         z++
      //       ) {
      //         if (result.sketchCommands[0].details[y].arcData[z]) {
      //           arcs++;
      //         }
      //       }
      //     }
      //   }
      //   newRow.improvementDetail = improvementDetail;
      //   newRow.area = (area / 100).toFixed(1);
      //   newRow.perimeter = (perimeter / 10).toFixed(1);
      //   newRow.nodes = nodes;
      //   newRow.arcs = arcs;
      //   if (!(area === 0 && perimeter === 0 && nodes === 0 && arcs === 0)) {
      //     result.table.push(newRow);
      //   }
      // }
      // if (result.table.length === 0) {
      //   result.table = [
      //     {
      //       improvementDetail: 'N/A',
      //       area: 0,
      //       perimeter: 0,
      //       nodes: 0,
      //       arcs: 0,
      //     },
      //   ];
      // }
      return state
        .setIn(['editSketch', 'state'], fetchingState.LOADED)
        .setIn(['editSketch', 'data'], fromJS(result));
    }
    case actions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(['config', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case actions.SAVE_SKETCH_SUCCESS: {
      return state;
    }
    case actions.UPDATE_CI_RECORD_SUCCESS: {
      return state;
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.SET_GISSETTINGS: {
      return state.setIn(['gisSettings', 'data'], fromJS(action.windowData));
    }
    case actions.SET_GISSETTINGSSTATE: {
      return state.setIn(['gisSettings', 'state'], fromJS(action.windowData));
    }
    case actions.SET_CISETTINGS: {
      return state.setIn(['ciSettings', 'data'], fromJS(action.windowData));
    }
    case actions.SET_APPRAISALMAPDATA: {
      return state.setIn(
        ['appraisalMapData', 'data'],
        fromJS(action.windowData),
      );
    }
    case actions.SET_MAPDATA: {
      return state.setIn(['mapData', 'data'], fromJS(action.windowData));
    }
    case actions.SET_APPRAISALMAPCOORDS: {
      return state
        .setIn(
          ['appraisalMapData', 'data', 'lastModifiedIndex'],
          fromJS(action.windowData.lastModifiedIndex),
        )
        .setIn(
          ['appraisalMapData', 'data', 'lat'],
          fromJS(action.windowData.lat),
        )
        .setIn(
          ['appraisalMapData', 'data', 'lng'],
          fromJS(action.windowData.lng),
        );
    }
    case actions.SET_MAPCOORDS: {
      return state
        .setIn(
          ['mapData', 'data', 'lastModifiedIndex'],
          fromJS(action.windowData.lastModifiedIndex),
        )
        .setIn(['mapData', 'data', 'lat'], fromJS(action.windowData.lat))
        .setIn(['mapData', 'data', 'lng'], fromJS(action.windowData.lng));
    }
    case actions.GET_PID_ADDRESS_DATA_START: {
      return state.setIn(['addressFetchData', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_APPRAISAL_CI_INITIAL_DATA_START: {
      let data = state.getIn(['appraisalMapData', 'data']).toJS();
      data.loaded = false;
      return state.setIn(['appraisalMapData', 'data'], fromJS(data));
    }
    case actions.GET_CI_API_SETTINGS_START: {
      return state.setIn(['ciSettings', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_GIS_API_SETTINGS_START: {
      return state.setIn(['gisSettings', 'state'], fetchingState.FETCHING);
    }
    case actions.SET_CI_API_SETTINGS_START: {
      return state;
    }
    case actions.SET_GIS_API_SETTINGS_START: {
      return state;
    }
    case actions.GET_APPRAISAL_SEARCH_DATA_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_APPRAISAL_CI_POPUP_CONTENT_START: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_POPUP_CONTENT_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_TAXING_UNITS_START: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_TAGS_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_TAG_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_COMMENTS_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.CREATE_CI_RECORD_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_CI_RECORD_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.EDIT_CI_RECORD_START: {
      return state.setIn(['editSketch', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SAVE_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_CI_RECORD_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_PID_ADDRESS_DATA_ERROR: {
      return state.setIn(['addressFetchData', 'state'], fetchingState.ERROR);
    }
    case actions.GET_APPRAISAL_CI_INITIAL_DATA_ERROR: {
      let data = state.getIn(['appraisalMapData', 'data']).toJS();
      data.loaded = false;
      return state.setIn(['appraisalMapData', 'data'], fromJS(data));
    }
    case actions.GET_CI_API_SETTINGS_ERROR: {
      return state.setIn(['ciSettings', 'state'], fetchingState.ERROR);
    }
    case actions.GET_GIS_API_SETTINGS_ERROR: {
      return state.setIn(['gisSettings', 'state'], fetchingState.ERROR);
    }
    case actions.SET_CI_API_SETTINGS_ERROR: {
      return state.setIn(['ciSettings', 'state'], fetchingState.ERROR);
    }
    case actions.SET_GIS_API_SETTINGS_ERROR: {
      return state.setIn(['gisSettings', 'state'], fetchingState.ERROR);
    }
    case actions.GET_APPRAISAL_SEARCH_DATA_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_POPUP_CONTENT_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'error',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'error',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_APPRAISAL_CI_POPUP_CONTENT_ERROR: {
      let windowData = state
        .getIn(['appraisalMapData', 'data', 'windowData'])
        .toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'error',
        data: {},
      };
      return state.setIn(
        ['appraisalMapData', 'data', 'windowData'],
        fromJS(windowData),
      );
    }
    case actions.GET_TAXING_UNITS_ERROR: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.ERROR);
    }
    case actions.GET_TAGS_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.POST_TAG_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.GET_COMMENTS_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.POST_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.CREATE_CI_RECORD_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_CI_RECORD_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.EDIT_CI_RECORD_ERROR: {
      return state.setIn(['editSketch', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }
    case actions.SAVE_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_CI_RECORD_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    default: {
      return state;
    }
  }
};

export default SearchReducer;
